import {changeFieldProperty, setFieldVisibility, setDataList} from "../../../../../apps/KpModule/actions"
import {generateFetchFieldListAction, GET_OBJECT_SUCCESS} from "../../../../../apps/KpModule/actions/api"
import moment from "moment"
import {ObjectId} from "bson"
import _ from "lodash"
import {getFormValues} from "redux-form"
import {calculateReversionMaxAmount} from "../utils"
import {liberalityReversionDepartureStatusObjects} from "../../staticEntities"

const recalculateReversionMaxAmount = (module, store) => {
    const departuresField = module.viewMap.form.fields.find(f => f.path === 'departures')
    const getField = path => departuresField.viewMap.form.fields.find(f => f.path === path)

    const reversionMaxAmountField = getField('reversionMaxAmount')
    const reversionAmountField = getField('reversionAmount')

    const beneficiary = getField('beneficiary').getValue()
    const asset = getField('asset').getValue()

    if (!beneficiary?.id || !asset?.id) {
        reversionMaxAmountField.setValue(0)
        //store.dispatch(changeFieldProperty(reversionAmountField.id, 'maxValue', 0))
        return
    }

    const state = store.getState()
    const currentDeparture = getFormValues('departuresEditObject')(state) || {}
    const liberalityRecord = getFormValues('editObject')(state) || {}

    const reversionMaxAmount = calculateReversionMaxAmount({
        id: currentDeparture.id,
        beneficiary,
        asset,
        liberalityRecord: liberalityRecord
    })

    reversionMaxAmountField.setValue(reversionMaxAmount)
    //store.dispatch(changeFieldProperty(reversionAmountField.id, 'maxValue', reversionMaxAmount))
}

const recalculateAdvanceRecoveryMaxAmount = (module, store, beneficiaryId) => {
    const departuresField = module.viewMap.form.fields.find(f => f.path === 'departures')
    const getField = path => departuresField.viewMap.form.fields.find(f => f.path === path)

    const advanceRecoveryMaxAmountField = getField('advanceRecoveryMaxAmount')
    const advanceRecoveryAmountField = getField('advanceRecoveryAmount')

    if (!beneficiaryId) {
        advanceRecoveryMaxAmountField.setValue(0)
        store.dispatch(changeFieldProperty(advanceRecoveryAmountField.id, 'maxValue', 0))
        return
    }

    store.dispatch(generateFetchFieldListAction(
        "m-C-liberalityReversion.LiberalityReversionDeparture_advance",
        store.getState,
        {data: {beneficiaryId}}
    )).then(action => {
        const advance = (action?.data || [])[0]
        const advanceRecoveryMaxAmount = advance ? (advance.grantedTotal - advance.imputedTotal) : 0

        advanceRecoveryMaxAmountField.setValue(advanceRecoveryMaxAmount)
        store.dispatch(changeFieldProperty(advanceRecoveryAmountField.id, 'maxValue', advanceRecoveryMaxAmount))
    })
}

export const module_ = {
    object: 'LiberalityRecord',
    name: 'LiberalityReversion',
    tKey: 'Reversion',
    category: {
        path: 'menuTitle_liberalities',
        icon: 'testament'
    },
    defaultSortBy: 'updatedAt',
    defaultSortDirection: 'DESC',
    newable: false,
    viewMap: {
        dt: [
            {path: 'fileApplicationNumberAndBenefactor', tKey: 'Dossier'},
            {path: 'administrator', display: 'fullName', tKey: 'Gestionnaire'},
            {path: 'typeOfFile', display: 'code', tKey: 'Nature dossier', initiallyNotVisible: true},
            {path: 'benefactor', tKey: 'Bienfaiteur(rice)', initiallyNotVisible: true},
            {path: 'decisionDate', tKey: 'Date décision', initiallyNotVisible: true},
            {path: 'beneficiaries', tKey: 'Bénéficiaire(s)', initiallyNotVisible: true},

            {path: 'netForecastTotal', tKey: 'Net prévu (€)', initiallyNotVisible: true, tooltip: true},
            {path: 'netAchievedTotal', tKey: 'Net réalisé (€)', initiallyNotVisible: true, tooltip: true},
            {path: 'receivedTotal', tKey: 'Reçu (€)', tooltip: true},
            {path: 'reversedTotal', tKey: 'Reversé (€)', tooltip: true},
            {path: 'advanceRecoveryTotal', tKey: "Reprise d'avance (€)", tooltip: true},
            {path: 'CNDAShareTotal', tKey: 'Part CNDA (€)', tooltip: true},

            {path: 'updatedBy', tKey: 'MAJ par'},
            {path: 'updatedAt', tKey: 'MAJ le'},
            {path: 'noDeleteButtonAccess', hidden: true},
        ],
        form: {
            fields: [
                {
                    path: 'fileApplicationNumberAndBenefactor',
                    disabled: true,
                    widthClassName: 'col-xs-12 col-sm-6',
                    tKey: 'Dossier'
                },
                {path: 'administrator', display: 'fullName', tKey: 'Gestionnaire', disabled: true, widthClassName: 'col-xs-12 col-sm-6'},
                {path: 'typeOfFile', display: 'fullName', tKey: 'Nature dossier', disabled: true, widthClassName: 'col-xs-12 col-sm-6'},
                {path: 'benefactor', tKey: 'Bienfaiteur(rice)', disabled: true, widthClassName: 'col-xs-12 col-sm-6'},
                {path: 'decisionDate', tKey: 'Date décision', disabled: true, widthClassName: 'col-xs-12 col-sm-6'},
                {path: 'beneficiaries', tKey: 'Bénéficiaire(s)', disabled: true},

                {
                    path: 'assetsInfos',
                    tKey: 'Suivi des biens',
                    newable: false,
                    removable: false,
                    defaultSortBy: 'achievedDate',
                    defaultSortDirection: 'DESC',
                    viewMap: {
                        dt: [
                            {path: 'typeOfProperty', tKey: 'Catégorie'},
                            {path: 'identifier', tKey: 'Bien'},
                            {path: 'estimatedAssetNetValue', tKey: 'Net prévu (€)', type: 'number', numberOfDecimals: 2, tooltip: true},
                            {path: 'netAmount', tKey: 'Net réalisé (€)', tooltip: true},
                            {path: 'achievedDate', tKey: 'Réalisé le'},
                        ],
                        form: [
                            {
                                path: 'distribution',
                                hidden: true,
                                viewMap: {
                                    dt: [{path: 'beneficiary', fieldPath: ['id', 'zipCodeAndName']}, 'share'],
                                    form: [{path: 'beneficiary', fieldPath: ['id', 'zipCodeAndName']}, 'share']
                                }
                            },
                            {path: 'typeOfProperty', tKey: 'Catégorie', disabled: true, widthClassName: 'col-xs-12 col-sm-6'},
                            {path: 'identifier', tKey: 'Bien', disabled: true, widthClassName: 'col-xs-12 col-sm-6'},
                            {path: 'estimatedAssetNetValue', tKey: 'Net prévu (€)', disabled: true, widthClassName: 'col-xs-12 col-sm-6'},
                            {
                                path: 'netAmount',
                                tKey: 'Net réalisé (€)',
                                required: true,
                                minValue: 0,
                                widthClassName: 'col-xs-12 col-sm-6',
                                subscriptions: {
                                    onChange: (newValue, oldValue, {formInitialize, module, store}) => {
                                        if (!formInitialize) return
                                        const assetsField = module.viewMap.form.fields.find(f => f.path === 'assetsInfos')
                                        const netAmountField = assetsField.viewMap.form.fields.find(f => f.path === 'netAmount')
                                        store.dispatch(changeFieldProperty(netAmountField.id, 'editable', !newValue))
                                    }
                                }
                            },
                            {
                                path: 'achievedDate',
                                tKey: 'Réalisé le',
                                required: true,
                                endDate: moment().format('YYYY-MM-DD'),
                                widthClassName: 'col-xs-12 col-sm-6',
                                subscriptions: {
                                    onChange: (newValue, oldValue, {formInitialize, module, store}) => {
                                        if (!formInitialize) return
                                        const assetsField = module.viewMap.form.fields.find(f => f.path === 'assetsInfos')
                                        const achievedDateField = assetsField.viewMap.form.fields.find(f => f.path === 'achievedDate')
                                        store.dispatch(changeFieldProperty(achievedDateField.id, 'editable', !newValue))
                                    }
                                }
                            },
                        ]
                    }
                },

                {
                    path: 'entries',
                    tKey: 'Suivi des entrées',
                    removable: false,
                    defaultSortBy: 'date',
                    defaultSortDirection: 'DESC',
                    viewMap: {
                        dt: [
                            {path: 'date', tKey: 'Date'},
                            {path: 'receivedAmount', tKey: 'Reçu (€)', tooltip: true},
                            {path: 'asset', tKey: 'Bien', display: 'identifier'},
                            {path: 'reason', tKey: 'Motif', display: 'name'},
                            {path: 'CNDAShare', tKey: 'Part CNDA (€)', tooltip: true},
                        ],
                        form: [
                            {
                                path: 'date',
                                tKey: 'Date',
                                required: true,
                                editable: false,
                                endDate: moment().format('YYYY-MM-DD'),
                                widthClassName: 'col-xs-12 col-sm-6',
                            },
                            {
                                path: 'receivedAmount',
                                tKey: 'Reçu (€)',
                                required: true,
                                editable: false,
                                minValue: 0,
                                widthClassName: 'col-xs-12 col-sm-6',
                                subscriptions: {
                                    onChange: (newValue, oldValue, {module}) => {
                                        const entriesField = module.viewMap.form.fields.find(f => f.path === 'entries')
                                        const CNDAShareField = entriesField.viewMap.form.fields.find(f => f.path === 'CNDAShare')

                                        const decisionDateField = module.viewMap.form.fields.find(f => f.path === 'decisionDate')
                                        const decisionDate = decisionDateField.getValue()
                                        const rate = decisionDate && moment(decisionDate).isSameOrAfter('2021-09-01', 'day') ? 6 : 3

                                        CNDAShareField.setValue((newValue ?? 0) * rate / 100)
                                    }
                                }
                            },
                            {
                                path: 'asset',
                                tKey: 'Bien',
                                display: 'identifier',
                                required: true,
                                filters: ['byLiberalityRecord'],
                                widthClassName: 'col-xs-12 col-sm-6',
                            },
                            {
                                path: 'reason',
                                tKey: 'Motif',
                                display: 'name',
                                required: true,
                                sortList: false,
                                widthClassName: 'col-xs-12 col-sm-6',
                            },
                            {path: 'comment', tKey: 'Commentaire', type: 'richTextEditor'},
                            {path: 'CNDAShare', tKey: 'Part CNDA (€)', disabled: true, default: 0, widthClassName: 'col-xs-12 col-sm-6'},
                        ]
                    }
                },

                {
                    path: 'receivables',
                    tKey: 'Dettes',
                    defaultSortBy: 'pieceDate',
                    defaultSortDirection: 'DESC',
                    viewMap: {
                        dt: [
                            {path: 'pieceNumber', tKey: 'N° pièce'},
                            {path: 'pieceDate', tKey: 'Date pièce'},
                            {path: 'creditor', tKey: 'Créancier', display: 'name'},
                            {path: 'expenseCategory', tKey: 'Catégorie', display: 'name', initiallyNotVisible: true},
                            {path: 'totalAmount', tKey: 'Total (€)', tooltip: true},
                            {path: 'dueDate', tKey: "Date d'échéance", initiallyNotVisible: true},
                            {path: 'status', tKey: 'Statut', display: 'name'},
                            {path: 'settlementDate', tKey: 'Date règlement', initiallyNotVisible: true},
                        ],
                        form: [
                            {path: 'pieceNumber', tKey: 'N° pièce', required: true, widthClassName: 'col-xs-12 col-sm-6'},
                            {
                                path: 'pieceDate',
                                tKey: 'Date pièce',
                                required: true,
                                endDate: moment().format('YYYY-MM-DD'),
                                widthClassName: 'col-xs-12 col-sm-6'
                            },
                            {
                                path: 'creditor',
                                tKey: 'Créancier',
                                display: 'name',
                                required: true,
                                filters: ['isSupplier'],
                                widthClassName: 'col-xs-12 col-sm-6'
                            },
                            {
                                path: 'expenseCategory',
                                tKey: 'Catégorie',
                                display: 'name',
                                required: true,
                                filters: ['active'],
                                widthClassName: 'col-xs-12 col-sm-6'
                            },
                            {
                                path: 'totalAmount',
                                tKey: 'Total (€)',
                                required: true,
                                minValue: 0,
                                widthClassName: 'col-xs-12 col-sm-6'
                            },
                            {path: 'dueDate', tKey: "Date d'échéance", startDate: moment().format('YYYY-MM-DD'), widthClassName: 'col-xs-12 col-sm-6'},
                            {
                                path: 'imputations',
                                tKey: 'Imputation(s)',
                                viewMap: {
                                    dt: [
                                        {path: 'asset', tKey: 'Bien', display: 'identifier'},
                                        {path: 'beneficiary', tKey: 'Bénéficiaire', display: 'zipCodeAndName'},
                                        {path: 'imputedAmount', tKey: 'Mt imputé (€)', type: 'editText', editable: true},
                                    ]
                                },
                                validations: [
                                    function() {
                                        return function validation(value, values) {
                                            const totalAmount = values.totalAmount
                                            const imputedTotal = _.sumBy(value || [], o => Number(o.imputedAmount) || 0)
                                            return Math.abs((totalAmount || 0) - imputedTotal) > 0 ? 'imputedAmountsMustEqualTotalAmount' : undefined
                                        }
                                    }
                                ]
                            },
                            {
                                path: 'status',
                                tKey: 'Statut',
                                display: 'name',
                                required: true,
                                sortList: false,
                                widthClassName: 'col-xs-12 col-sm-6',
                                subscriptions: {
                                    onChange: (newValue, oldValue, {module, store, formInitialize}) => {
                                        const receivablesField = module.viewMap.form.fields.find(f => f.path === 'receivables')
                                        const settlementDateField = receivablesField.viewMap.form.fields.find(f => f.path === 'settlementDate')

                                        if (!formInitialize) {
                                            settlementDateField.setValue(null)
                                        }

                                        const isSettled = newValue?.id === 'settled'
                                        store.dispatch(setFieldVisibility(settlementDateField.id, isSettled))
                                        store.dispatch(changeFieldProperty(settlementDateField.id, 'required', isSettled))
                                    }
                                }
                            },
                            {
                                path: 'settlementDate',
                                tKey: 'Date de règlement',
                                hidden: true,
                                maxDate: moment().format('YYYY-MM-DD'),
                                widthClassName: 'col-xs-12 col-sm-6'
                            },
                            {path: 'comment', tKey: 'Commentaire', type: 'richTextEditor'},
                            {path: 'files', tKey: 'Pièces', type: 'simpleFiles'}
                        ]
                    }
                },

                {
                    path: 'departures',
                    tKey: 'Suivi des sorties',
                    removable: false,
                    defaultSortBy: 'date',
                    defaultSortDirection: 'DESC',
                    viewMap: {
                        dt: [
                            {path: 'date', tKey: 'Date'},
                            {path: 'beneficiary', tKey: 'Bénéficiaire', display: 'zipCodeAndName'},
                            {path: 'asset', tKey: 'Bien', display: 'identifier'},
                            {path: 'reversionAmount', tKey: 'Reversion (€)', tooltip: true},
                            {path: 'advanceRecoveryAmount', tKey: "Reprise d'avance (€)", tooltip: true},
                            {path: 'status', tKey: 'Statut', display: 'name', initiallyNotVisible: true},
                            {path: 'executedDate', tKey: 'Exécuté le'},
                        ],
                        form: [
                            {
                                path: 'date',
                                tKey: 'Date',
                                required: true,
                                endDate: moment().format('YYYY-MM-DD'),
                                editable: false,
                                widthClassName: 'col-xs-12 col-sm-6',
                                subscriptions: {
                                    onChange: (newValue, oldValue, {module, store}) => {
                                        const departuresField = module.viewMap.form.fields.find(f => f.path === 'departures')
                                        const executedDateField = departuresField.viewMap.form.fields.find(f => f.path === 'executedDate')
                                        store.dispatch(changeFieldProperty(executedDateField.id, 'startDate', newValue))
                                    }
                                }
                            },
                            {
                                path: 'beneficiary',
                                tKey: 'Bénéficiaire',
                                display: 'zipCodeAndName',
                                required: true,
                                filters: ['inLiberalityRecordDistribution'],
                                widthClassName: 'col-xs-12 col-sm-6',
                                subscriptions: {
                                    onChange: (newValue, oldValue, {module, store}) => {
                                        const liberalityRecordId = getFormValues('editObject')(store.getState())?.id
                                        if (!liberalityRecordId) return

                                        store.dispatch(generateFetchFieldListAction(
                                            "m-C-liberalityReversion.LiberalityReversionDeparture_asset",
                                            store.getState,
                                            {data: {liberalityRecordId, beneficiaryId: newValue?.id}}
                                        ))

                                        recalculateReversionMaxAmount(module, store)
                                        recalculateAdvanceRecoveryMaxAmount(module, store, newValue?.id)
                                    }
                                }
                            },
                            {
                                path: 'asset',
                                tKey: 'Bien',
                                display: 'identifier',
                                required: true,
                                filters: ['byLiberalityRecordAndBeneficiary'],
                                widthClassName: 'col-xs-12 col-sm-6',
                                subscriptions: {
                                    onChange: (newValue, oldValue, {module, store}) => {
                                        recalculateReversionMaxAmount(module, store)
                                    }
                                }
                            },
                            {
                                path: 'advance',
                                hidden: true,
                                filters: ['byBeneficiary'],
                                fieldPath: ['grantedTotal', 'imputedTotal'],
                            },
                            {
                                path: 'departureForm',
                                tKey: 'Forme',
                                display: 'name',
                                required: true,
                                sortList: false,
                                widthClassName: 'col-xs-12 col-sm-6',
                                subscriptions: {
                                    onChange: (newValue, oldValue, {module, store, formInitialize}) => {
                                        const departuresField = module.viewMap.form.fields.find(f => f.path === 'departures')
                                        const getField = path => departuresField.viewMap.form.fields.find(f => f.path === path)

                                        const isReversion = newValue?.id === 'reversion'
                                        const isAdvanceRecovery = newValue?.id === 'advanceRecovery'

                                        store.dispatch(setFieldVisibility(getField('reversionMaxAmount').id, isReversion))
                                        store.dispatch(setFieldVisibility(getField('reversionAmount').id, isReversion))
                                        store.dispatch(changeFieldProperty(getField('reversionAmount').id, 'required', isReversion))

                                        store.dispatch(setFieldVisibility(getField('advanceRecoveryMaxAmount').id, isAdvanceRecovery))
                                        store.dispatch(setFieldVisibility(getField('advanceRecoveryAmount').id, isAdvanceRecovery))
                                        store.dispatch(changeFieldProperty(getField('advanceRecoveryAmount').id, 'required', isAdvanceRecovery))

                                        const statusField = getField('status')
                                        store.dispatch(setFieldVisibility(statusField.id, isReversion))

                                        const executedDateField = getField('executedDate')

                                        if (isAdvanceRecovery) {
                                            statusField.setValue(liberalityReversionDepartureStatusObjects.find(status => status.id === 'allocated'))
                                            executedDateField.setValue(moment().format('YYYY-MM-DD'))
                                            store.dispatch(setFieldVisibility(executedDateField.id, false))
                                        } else if (isReversion) {
                                            store.dispatch(setDataList(
                                                "m-C-liberalityReversion.LiberalityReversionDeparture_status",
                                                liberalityReversionDepartureStatusObjects.filter(status => status.id !== 'allocated')
                                            ))
                                            if (statusField.getValue()?.id === 'allocated') statusField.setValue(null)
                                        }

                                        if (!formInitialize) {
                                            if (!isAdvanceRecovery) getField('advanceRecoveryAmount').setValue(null)
                                            if (!isReversion) getField('reversionAmount').setValue(null)
                                        }
                                    }
                                }
                            },
                            {
                                path: 'reversionMaxAmount',
                                tKey: 'Reversion maximum (€)',
                                disabled: true,
                                hidden: true,
                                widthClassName: 'col-xs-12 col-sm-6',
                            },
                            {
                                path: 'reversionAmount',
                                tKey: 'Reversion (€)',
                                minValue: 0,
                                hidden: true,
                                widthClassName: 'col-xs-12 col-sm-6',
                            },
                            {
                                path: 'advanceRecoveryMaxAmount',
                                tKey: "Reprise d'avance (€) maximum (€)",
                                disabled: true,
                                hidden: true,
                                widthClassName: 'col-xs-12 col-sm-6',
                            },
                            {
                                path: 'advanceRecoveryAmount',
                                tKey: "Reprise d'avance (€)",
                                minValue: 0,
                                hidden: true,
                                widthClassName: 'col-xs-12 col-sm-6',
                            },
                            {path: 'comment', tKey: 'Commentaire', type: 'richTextEditor'},
                            {
                                path: 'status',
                                tKey: 'Statut',
                                display: 'name',
                                required: true,
                                sortList: false,
                                widthClassName: 'col-xs-12 col-sm-6',
                                subscriptions: {
                                    onChange: (newValue, oldValue, {module, store, formInitialize}) => {
                                        const departuresField = module.viewMap.form.fields.find(f => f.path === 'departures')
                                        const executedDateField = departuresField.viewMap.form.fields.find(f => f.path === 'executedDate')
                                        const reversionAmountField = departuresField.viewMap.form.fields.find(f => f.path === 'reversionAmount')
                                        const advanceRecoveryAmountField = departuresField.viewMap.form.fields.find(f => f.path === 'advanceRecoveryAmount')

                                        if (!formInitialize) {
                                            executedDateField.setValue(null)
                                        }

                                        const isExecuted = newValue?.id === 'paid'
                                        const isAllocated = newValue?.id === 'allocated'
                                        store.dispatch(setFieldVisibility(executedDateField.id, isExecuted))
                                        store.dispatch(changeFieldProperty(executedDateField.id, 'required', isExecuted))
                                        store.dispatch(changeFieldProperty(reversionAmountField.id, 'editable', !isExecuted))
                                        store.dispatch(changeFieldProperty(advanceRecoveryAmountField.id, 'editable', !isAllocated))
                                    }
                                }
                            },
                            {
                                path: 'executedDate',
                                tKey: 'Exécuté le',
                                hidden: true,
                                endDate: moment().format('YYYY-MM-DD'),
                                widthClassName: 'col-xs-12 col-sm-6',
                                subscriptions: {
                                    onChange: (newValue, oldValue, {formInitialize, module, store}) => {
                                        if (!formInitialize) return
                                        const departuresField = module.viewMap.form.fields.find(f => f.path === 'departures')
                                        const executedDateField = departuresField.viewMap.form.fields.find(f => f.path === 'executedDate')
                                        store.dispatch(changeFieldProperty(executedDateField.id, 'editable', !newValue))
                                    }
                                }
                            },
                        ]
                    }
                },

                {path: 'conversations', tKey: "zone d'échanges"}
            ],
        }
    },
    filters: ['accepted'],
    actionSubscriptions: [
        {
            actionType: GET_OBJECT_SUCCESS,
            subscription: ({ store, module }) => {
                const state = store.getState()
                const liberalityRecord = _.pick(state.edit.object.data, ['id'])
                const assetsInfos = _.get(state, 'edit.object.data.assetsInfos')

                const imputationTemplate = (assetsInfos || []).flatMap(assetInfo =>
                    (assetInfo.distribution || []).map(dist => ({
                        id: new ObjectId(),
                        asset: {id: assetInfo.id, identifier: assetInfo.identifier},
                        beneficiary: dist.beneficiary,
                        imputedAmount: 0
                    }))
                )

                const receivablesField = module.viewMap.form.fields.find(f => f.path === 'receivables')
                const imputationsField = receivablesField.viewMap.form.fields.find(f => f.path === 'imputations')
                store.dispatch(changeFieldProperty(imputationsField.id, 'default', imputationTemplate))

                store.dispatch(generateFetchFieldListAction(
                    "m-C-liberalityReversion.LiberalityReversionEntry_asset",
                    store.getState,
                    {data: {liberalityRecordId: liberalityRecord?.id}}
                ))
                store.dispatch(generateFetchFieldListAction(
                    "m-C-liberalityReversion.LiberalityReversionDeparture_asset",
                    store.getState,
                    {data: {liberalityRecordId: liberalityRecord?.id}}
                ))
                store.dispatch(generateFetchFieldListAction(
                    "m-C-liberalityReversion.LiberalityReversionDeparture_beneficiary",
                    store.getState,
                    {data: {liberalityRecordId: liberalityRecord?.id}}
                ))
            }
        }
    ]
}